import { s3Service } from './s3Service';
import { CSVData } from '../utils/csvParser';
import { awsConfig } from '../config/aws-config';

export const downloadService = {
  // Download table data as CSV
  downloadTableAsCSV(data: CSVData[], filename: string) {
    if (data.length === 0) {
      alert('No data available to download');
      return;
    }

    // Get headers from first row
    const headers = Object.keys(data[0]);
    
    // Create CSV content
    const csvContent = [
      headers.join(','), // Header row
      ...data.map(row => 
        headers.map(header => {
          const value = row[header];
          // Wrap in quotes if contains comma or is string
          return typeof value === 'string' && value.includes(',') 
            ? `"${value}"` 
            : value;
        }).join(',')
      )
    ].join('\n');

    this.triggerDownload(csvContent, filename);
  },

  // Download raw CSV file from S3
  async downloadFromS3(folder: string, filename: string) {
    try {
      const content = await s3Service.getFileContent(`${folder}/${filename}`);
      if (!content) {
        alert(`File ${filename} not found`);
        return;
      }
      
      this.triggerDownload(content, filename);
    } catch (error: any) {
      console.error('Download error:', error);
      alert(`Error downloading ${filename}: ${error.message}`);
    }
  },

  // Trigger browser download
  triggerDownload(content: string, filename: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  },

  // Download multiple files from S3 (for bulk download)
  async downloadAllFiles(folder: string) {
    // Determine which files to download based on folder path
    const files = folder.startsWith('ICE-VEHICLE-LOOKUP/') 
      ? [
          'network_all.csv',
          'network_success.csv',
          'network_failure.csv',
          'client_summary.csv',
          'client_failure_summary.csv'
        ]
      : awsConfig.showNetworkLogs 
        ? [
            'activity_all.csv',
            'activity_success.csv',
            'activity_failure.csv',
            'network_all.csv',
            'network_success.csv',
            'network_failure.csv'
          ]
        : [
            'activity_all.csv',
            'activity_success.csv',
            'activity_failure.csv'
          ];

    for (const file of files) {
      try {
        await this.downloadFromS3(folder, file);
        // Small delay between downloads
        await new Promise(resolve => setTimeout(resolve, 500));
      } catch (error) {
        console.error(`Failed to download ${file}:`, error);
      }
    }
  }
}; 